import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M10 9h4l-2 6","key":"svg-1"}],["path",{"d":"M8 6h.01","key":"svg-2"}],["path",{"d":"M16 18h.01","key":"svg-3"}]]

const IconPlayCard7 = createReactComponent('outline', 'play-card-7', 'PlayCard7', __iconNode);

export default IconPlayCard7;